import styles from './APIDetailsSection.module.scss';

import React from 'react';
import { Container } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeRight, FadeUp } from 'src/components/Animations';
import RetinaImage from 'src/components/RetinaImage';

import ImgLaptopZoneAndWeight from 'src/images/img-laptop-zone-and-weight.png';
import ImgLaptopZoneAndWeight2x from 'src/images/img-laptop-zone-and-weight@2x.png';

export default (props) => (
  <ScrollOverPack styleName='api-details-section'>
      <TweenOne key='container' component={Container} {...FadeUp}>
          <div styleName='text-container'>
              <div className='h2 text-blue'>
                  Get deeper insights
              </div>
              <div className='h2'>
                  Deliver better experiences.
              </div>
              <p styleName='message'>
                  Have you ever wondered how delivery speed affects customer
                  retention? Or wanted to calculate your fully-loaded unit costs?
                  Joining accurate, shipment-level data with what’s already in
                  your database can lead you to powerful insights with actionable
                  outcomes.
              </p>
          </div>
      </TweenOne>
      <TweenOne key='splash-image-container'
                styleName='splash-image-container'
                {...FadeRight}>
          <RetinaImage srcSet={[ImgLaptopZoneAndWeight, ImgLaptopZoneAndWeight2x]}
                       styleName='splash-image' />
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/APIDetailsSection.js